module.exports = __webpack_public_path__ + "img/poi_icon_trip_advisor.60aba0f.png";